import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import { MODALS } from '~redux/Modal/constants';
import ModalActions from '~redux/Modal/actions';

import { KINDS, MESSAGES_COMPONENTS } from './constants';
import styles from './styles.module.scss';

const getMessageComponent = (name) => MESSAGES_COMPONENTS[name] || (({ children }) => <>{children}</>);

const TopSiteMessage = () => {
  const dispatch = useDispatch();
  const { message, kind, name } = useSelector((state) => state.modal[MODALS.TOP_SITE_MESSAGE]?.data);
  const closeModal = () => dispatch(ModalActions.closeModalWithData(MODALS.TOP_SITE_MESSAGE));
  const Message = getMessageComponent(name);

  return (
    <div
      className={cn('text-center', styles.containerTopSiteMessage, {
        [styles.alertMessage]: KINDS.ALERT === kind,
        [styles.warningMessage]: KINDS.WARNING === kind,
        [styles.infoMessage]: KINDS.INFO === kind,
        [styles.successMessage]: KINDS.SUCCESS === kind
      })}>
      {KINDS.WARNING === kind && <i className={`icon-notification ${styles.iconNotification}`} />}
      <span className="column center justify middle full-width">
        <Message>{message}</Message>
      </span>
      <button type="button" onClick={closeModal}>
        <i className={`icon-close ${styles.iconClose}`} />
      </button>
    </div>
  );
};

export default TopSiteMessage;
